import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { config } from '../../utils/config';
import { Input, message, DatePicker, Select } from 'antd'
import moment from 'moment'
import { Page, Crud, PageDetail, Upload } from '../../components'
const Option = Select.Option;
const { SelectFile } = Upload;
const { CrudTable, CrudForm, CrudFilter, CrudButtons } = Crud

export class Frui_pfxhPage extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { frui_pfxhPage, currentFrui_pfxh } = this.props.user;
    const { getFrui_qppzList , getFrui_pfbzList } = this.props.actions
    this.fetchList(frui_pfxhPage);
    getFrui_qppzList({ page: 1, size: 999 });
    getFrui_pfbzList({page:1,size:99999});
  }

  fetchList = (page, values) => {
    console.log('fetchList' , values);
    const { getFrui_pfxhList } = this.props.actions;
    let params = Object.assign({}, { page: page , orderBy: 'insert_time desc'}, values)
    getFrui_pfxhList(params);
  }
  
  getDataSource() {
    const { user } = this.props;
    const { frui_pfxhById, frui_pfxhList } = user;
    if (!frui_pfxhList) return [];
    return frui_pfxhList.map(id => frui_pfxhById[id]);
  }

  get listProps() {
    const { user, actions } = this.props
    const { getFrui_pfxhListPending, frui_pfxhTotal, frui_pfxhPage, fruiPfxhtypeTestsModalVisible } = user
    const { deleteFrui_pfxh, chooseCurrentFrui_pfxh,
      frui_pfxhModalChange,
      fruiPfxhtypeTestsModalChange,
      getQueryQpxxIdActions,
      hadleTongBuActions,
     } = actions;

    return {
      dataSource: this.getDataSource(),
      loading: getFrui_pfxhListPending,
      scroll: { x: 1300 },
      columns: [
        {
          title: "气瓶型号",
          dataIndex: 'typeName',
          key: 'typeName',
          width: 180,
        },
        {
          title: "气瓶结构",
          dataIndex: 'qpStructure',
          key: 'qpStructure',
          width: 180,
        },
        {
          title: "充装介质",
          dataIndex: 'mediumname',
          key: 'mediumname',
          width: 180,
        },
        {
          title: "气瓶品种",
          dataIndex: 'qpName',
          key: 'qpName',
          width: 180,
        },
        {
          title: "公称容积",
          dataIndex: 'rj',
          key: 'rj',
          width: 180,
        },
        {
          title: "工作压力",
          dataIndex: 'gzyl',
          key: 'gzyl',
          width: 180,
        },
        {
          title: "内胆筒体设计厚度",
          dataIndex: 'hdSjNd',
          key: 'hdSjNd',
          width: 180,
        },
        {
          title: "内胆设计壁厚",
          dataIndex: 'hdNd',
          key: 'hdNd',
          width: 180,
        },
        {
          title: "内胆直径",
          dataIndex: 'zjNd',
          key: 'zjNd',
          width: 180,
        },
      ],
      pagination: {
        total: frui_pfxhTotal,
        current: frui_pfxhPage,
        onChange: (page) => {
          this.fetchList(page);
        }
      },
      op: [
        {
          key: 2,
          name: '型式试验编辑',
        },
        {
          key: 3,
          name: '型式试验预览',
        },
        {
          key: 1,
          name: '编辑',
        },
        {
          key: 4,
          name: '型号同步',
        },
        {
          key: 5,
          name: '删除',
          buttonProps: {
            icon: "delete",
            type: "danger"
          },
          needConfirm: true,
          confirmTitle: "确认删除"
        }
      ],
      handleMenuClick: (record, item) => {
        console.log(record, item, '----------------------------')
        if (item.key == 1) {
          frui_pfxhModalChange(true, "updata");
          getQueryQpxxIdActions(record.id).then((res) => {
            chooseCurrentFrui_pfxh(res.data);
            console.log(res)
          })
        } else if (item.key === 2) {
          fruiPfxhtypeTestsModalChange(true, record)
          getQueryQpxxIdActions(record.id).then((res) => {
            chooseCurrentFrui_pfxh(res.data);
          })
        } else if (item.key === 3) {
          window.open(`${config.attachUrl}${record.xssyzsOssname}`)
        } else if (item.key === 4) {
          hadleTongBuActions(record.id).then(res => {
            if (res.code === 200) {
              message.success('同步成功')
            } else {
              message.error('同步失败')
            }
          })
        } else if (item.key === 5)  {
          deleteFrui_pfxh(record.id).then((data) => {
            //  console.log(frui_qpfjTotal)
            this.fetchList();
          })
        }
      } 
    }
  }

  // 型式试验
  get TypeModalProps() {
    const { actions, user } = this.props
    const { fruiPfxhtypeTestsModalVisible, submitFruiPfxhTypeTestsPending, fruiPfxhtypeTestsModalMessage, currentFrui_pfxh, frui_pfxhPage } = user
    const { submitFruiPfxhTypeTests, fruiPfxhtypeTestsModalChange, changeCurrentFruiPfxhTypeTests } = actions
    console.log(currentFrui_pfxh)
    let xssyzsOssname = []
    if (currentFrui_pfxh) {
      xssyzsOssname.push(currentFrui_pfxh.xssyzsOssname)
    }
    return {
      visible: fruiPfxhtypeTestsModalVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: submitFruiPfxhTypeTestsPending,
      title: '型式试验报告',
      centered: true,
      elements: [
        // {
        //   key: "xssyzsDateCy",
        //   label: "抽样日期",
        //   initialValue: currentFrui_pfxh !== undefined ? moment(currentFrui_pfxh.xssyzsDateCy) : '',
        //   widget: DatePicker,
        // },
        // {
        //   key: "xssyzsDateSj",
        //   label: "设计日期",
        //   initialValue: currentFrui_pfxh !== undefined ? moment(currentFrui_pfxh.xssyzsDateSj) : '',
        //   widget: DatePicker,
        // },
        // {
        //   key: "xssyzsDateSy",
        //   label: "试验日期",
        //   initialValue: currentFrui_pfxh !== undefined ? moment(currentFrui_pfxh.xssyzsDateSy) : '',
        //   widget: DatePicker,
        // },
        {
          key: "xssyzsNo",
          label: "报告编号",
          initialValue: currentFrui_pfxh !== undefined ? currentFrui_pfxh.xssyzsNo === undefined ? '' : currentFrui_pfxh.xssyzsNo : '',
          widget: Input,
        },
        {
          key: "xssyzsTh",
          label: "总图图号",
          initialValue: currentFrui_pfxh !== undefined ? currentFrui_pfxh.xssyzsTh === undefined ? '' : currentFrui_pfxh.xssyzsTh : '',
          widget: Input,
        },
        {
          key: "file",
          label: "上传文件",
          initialValue: currentFrui_pfxh !== undefined ? [] : xssyzsOssname,
          widget: SelectFile,
          widgetProps: {
          },
        },
      ],
      onOk: data => {
        let params = new FormData()
        params.append('file', data.file)
        // params.append('xssyzsDateCy', data.xssyzsDateCy.format('YYYY-MM-DD'))
        // params.append('xssyzsDateSj', data.xssyzsDateSj.format('YYYY-MM-DD'))
        // params.append('xssyzsDateSy', data.xssyzsDateSy.format('YYYY-MM-DD'))
        params.append('xssyzsNo', data.xssyzsNo)
        params.append('xssyzsTh', data.xssyzsTh)
        params.append('id', currentFrui_pfxh.id)
        submitFruiPfxhTypeTests(params).then(data => {
          fruiPfxhtypeTestsModalChange(false);
          changeCurrentFruiPfxhTypeTests(data)
          this.fetchList(frui_pfxhPage)
        })
      },
      onCancel() {
        fruiPfxhtypeTestsModalChange(false);
      },
    }
  }

  chooseStandard = () => {
    let { frui_pfbzById, frui_pfbzList } = this.props.user
    return frui_pfbzList
      .map(id => frui_pfbzById[id])
      .map(item => <Option key={item.bh}>{item.bh}</Option>);
  }


  choosePqpz = () => {
    let { user } = this.props;
    const { frui_qppzById, frui_qppzList } = user;
    return frui_qppzList.map(id => frui_qppzById[id]).map(item => <Option key={item.qpCode}>{item.qpName}</Option>)
  }

 

  get modalProps() {
    const { user, actions } = this.props
    const { currentFrui_pfxh, frui_pfxhModalVisible, frui_pfxhPage, frui_pfxhModalType, submitFrui_pfxhPending } = user

    const { frui_pfxhModalChange, submitFrui_pfxh } = actions;
    const editItem = frui_pfxhModalType === 'create' ? {} : currentFrui_pfxh
    return {
      item: frui_pfxhModalType === 'create' ? {} : currentFrui_pfxh,
      visible: frui_pfxhModalVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: submitFrui_pfxhPending,
      title: `${
      frui_pfxhModalType === 'create' ? `创建` : `更新`
      }`,
      centered: true,
      elements: [
        {
          key: "typeName",
          label: "气瓶型号",
          initialValue: editItem.typeName,
          widget: Input,
          required: true
        },
        {
          key: "qpStructure",
          label: "气瓶结构",
          initialValue: "绝热气瓶",
          widget: Input
        },
        {
          key: 'qpCode',
          label: '气瓶品种',
          initialValue: editItem.qpCode,
          widget: Select,
          children: this.choosePqpz(),
          required: true
        },
        {
          key: "rj",
          label: "公称容积",
          initialValue: editItem.rj,
          widget: Input,
        },
        {
          key: "jyzqSj",
          label: "设计检验周期",
          initialValue: editItem.jyzqSj,
          widget: Input,
        },
        {
          key: "life",
          label: "设计使用寿命",
          initialValue: editItem.life,
          widget: Input,
        },
        {
          key: "gzyl",
          label: "工作压力",
          initialValue: editItem.gzyl,
          widget: Input,
        },
        {
          key: "hdSjNd",
          label: "内胆筒体设计厚度",
          initialValue: editItem.hdSjNd,
          widget: Input,
        },
        {
          key: "hdNd",
          label: "内胆设计壁厚",
          initialValue: editItem.hdNd,
          widget: Input,
        },
        {
          key: "zl",
          label: "气瓶净重",
          initialValue: editItem.zl,
          widget: Input,
        },
        {
          key: "hdMyNd",
          label: "内胆名义厚度",
          initialValue: editItem.hdMyNd,
          widget: Input,
        },
        {
          key: "hdSjNft",
          label: "内封头设计厚度",
          initialValue: editItem.hdSjNft,
          widget: Input,
        },
        {
          key: "zjNd",
          label: "内胆直径",
          initialValue: editItem.zjNd,
          widget: Input,
        },
        {
          key: "syylNd",
          label: "内胆气压试验压力",
          initialValue: editItem.syylNd,
          widget: Input,
        },
        {
          key: "syylGl",
          label: "管路气密性试验压力",
          initialValue: editItem.syylGl,
          widget: Input,
        },
        {
          key: "typeTs",
          label: "探伤类型",
          initialValue: editItem.typeTs,
          widget: Input,
        },
        {
          key: "mediumname",
          label: "充装介质",
          initialValue: "液化天然气",
          widget: Input
        },
        {
          key: "fillingmediumcode",
          label: "填充介质代码",
          initialValue: editItem.fillingmediumcode,
          widget: Input,
        },
        {
          key: "czlMax",
          label: "最大充装量",
          initialValue: editItem.czlMax,
          widget: Input,
        },
        {
          key: "aqkj",
          label: "安全空间",
          initialValue: editItem.aqkj,
          widget: Input,
        },
        {
          key: "pbz",
          label: "产品标准",
          initialValue: `${editItem.pbz || ''}`,
          widget: Select,
          children: this.chooseStandard(),
          required: true
        },
        {
          key: "lb",
          label: "类别",
          initialValue: "B4",
          widget: Input
        },
      ],
      onOk: data => {
        console.log('data', data);
        let qpCode = data.qpCode;
        let qpName = this.getqpName(qpCode);

        submitFrui_pfxh(Object.assign({}, data, {qpName})).then(data => {
          frui_pfxhModalChange(false, "create");
          this.fetchList();
        })
      },
      onCancel() {
        frui_pfxhModalChange(false, "create");
      },
    }
  }


  getqpName = (qpCode) => {
     let { user } = this.props;
      const { frui_qppzById, frui_qppzList } = user;
      let qpName = ''
      frui_qppzList.map(item => frui_qppzById[item]).map(item => {
        if (item.qpCode == qpCode) {
          qpName = item.qpName;
        }
      })
      return qpName;
  }

  get buttonProps() {
    const { actions, user } = this.props
    const { currentFrui_pfxh, frui_pfxhPage } = user
    const { frui_pfxhModalChange } = actions;

    return {
      buttons: [
        {
          name: "新增",
          buttonProps: {
            type: "primary",
            icon: "plus",
          },
          onClick: () => { frui_pfxhModalChange(true, 'create') }
        }
      ]
    }
  }

  get filterProps() {
    const { actions, user } = this.props
    const { frui_pfxhPage, currentFrui_pfxh } = user;
    return {
      title: "",
      searchElements: [
        {
          key: "qpCode",
          widget: Select,
          widgetProps: {
            style: { width: 200 },
            placeholder: "气瓶品种",
          },
          children: this.choosePqpz()
        },
      ],
      onFilterChange: value => {
      
        this.fetchList(frui_pfxhPage,value)
      }
    }
  }

  render() {
    return (
      <Page inner>
        <CrudFilter {...this.filterProps} />
        <CrudButtons {...this.buttonProps} />
        <CrudTable {...this.listProps} />
        <CrudForm {...this.modalProps} />
        <CrudForm {...this.TypeModalProps} />
      </Page>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Frui_pfxhPage);


// WEBPACK FOOTER //
// ./src/features/user/Frui_pfxhPage.js